<template>
<div class="outer-region" :class="{focused, dark, plain, inline, 'read-only':readOnly}">
    <div ref="editRegion" :contenteditable="!readOnly" class="dotted-underline edit-region"
        @focus="gotFocus" @keydown.esc="cancel"
        @blur="changed" @keydown.enter="$event.target.blur()"
        @mousedown.stop>{{value}}</div>
</div>
</template>

<script>
import Utilities from '../helpers/Utilities'

export default {
    data() {
        return {
            backupText: null,
            focused: false,
        }
    },

    components: {
        
    },
    
    props: {
        value: [String, Number],
        width: {
            type: String,
            default: '30px',
        }, 
        dark: Boolean,
        plain: Boolean,
        readOnly: Boolean,
        inline: Boolean,
    },

    computed: {
        inputStyle() {
            return {
                width: this.width 
            }
        }
    },

    methods: {

        gotFocus(e) {
            console.log('got focus')
            this.focused = true
            this.backupText = e.target.innerText
            this.selectAll()
        },
        removeFocus(e) {
            this.focused = false
            this.backupText = null
            e.target.blur()
        },
        cancel(e) {
            e.target.innerText = this.backupText
            this.removeFocus(e)
        },
        changed(e) {
            e.preventDefault()
            const newText = e.target.innerText.trim()
            this.$emit('input', newText)
            if(e.target.innerText != this.backupText) {
                this.$emit('change', {value: e.target.innerText, oldValue: this.backupText})
            }
            this.removeFocus(e)
        },
        focus() {
            setTimeout( () => {
                this.$refs.editRegion.focus()
            },100)
        },
        selectAll() {
            const selection = window.getSelection()
            const range = document.createRange()
            range.selectNodeContents(this.$refs.editRegion)
            selection.removeAllRanges()
            selection.addRange(range)
        }
    },

    mounted() {
        
        if(this.value && this.value.toString().indexOf('...') > 0 && !this.readOnly) {
            this.focus()
            this.selectAll()
        }

    },

    created() {

    }
}
</script>

<style scoped>

    .outer-region {
        display: inline;
        /* display: inline-block; */
        border-radius:4px;
        padding:1px 2px;margin: -1px -2px;
        border: solid 1px transparent;
    }

    .outer-region.focused {
        border: solid 1px rgb(112, 184, 255);
    }
    .outer-region.inline.focused {
        border: solid 1px transparent;
        border-bottom: solid 1px rgb(112, 184, 255);
    }
    .outer-region.dark.focused {
        border: solid 1px white;
    }

    .outer-region.inline {
        display: inline;
        border-radius: 0;
    }

    .edit-region {
        text-decoration:underline;
        /* text-decoration-style:solid; */
        text-decoration-color: #bbb;
        display:inline-block;
        min-width:30px;
        cursor:pointer;
    }

    .inline .edit-region {
        display: inline;
    }

    .plain .edit-region {
        text-decoration:none;
    }

    .read-only .edit-region {
        user-select: none;
    }

    .edit-region:focus {
        outline: none;
        text-decoration: none;
    }
    .edit-region:hover {
        text-decoration-color: #777;

    }

</style>




// WEBPACK FOOTER //
// EditableText.vue?ac06ac94